import { useTranslation } from 'react-i18next'

import { GlobalNetIcon } from 'src/assets/icons'
import { SettingsDropdown, SettingsDropdownMobile } from 'src/components'
import { useModalState } from 'src/hooks'

import { Modal } from './modal.component'

interface IProps {
  mobile?: boolean
}

export const AccountLanguagesButton = ({ mobile }: IProps) => {
  const [t] = useTranslation()
  const { open, handleOpen, handleClose } = useModalState()

  // if (mobile) {
  //   return (
  //     <>
  //       <Modal open={open} handleClose={handleClose} />
  //     </>
  //   )
  // }

  return (
    <>
      {mobile ? (
        <SettingsDropdownMobile
          handleClick={handleOpen}
          icon={GlobalNetIcon}
          label={t('account-languages-section.v')}
        />
      ) : (
        <SettingsDropdown
          onButtonClick={handleOpen}
          text={t('account-languages-section.v')}
          icon={<GlobalNetIcon />}
        />
      )}
      <Modal open={open} handleClose={handleClose} />
    </>
  )
}
